import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';
import type { INpsPromptEnvelope, INpsPromptResponse } from '../types/NpsReview';

const NPS_PROMPT_PATH = '/auth-service/users/me/nps-prompt';

/**
 * Asks auth-service whether to show the NPS screen now: true when the person
 * never answered, or answered over 180 days ago and has used GoTu since. Replaces
 * the monolith's `show_nps`. Errors propagate; the caller decides what a failure means.
 *
 * Bounded by the app's remote-config API timeout, like the session refresh in
 * `services/api.js`: the post-review success modal waits on this answer, so a hung
 * auth-service must fail into "don't show" rather than keep the Send button loading.
 */
export const fetchNpsPrompt = async (): Promise<INpsPromptResponse> => {
  const headers = await getAuthHeaders();
  const timeoutMs = RemoteConfigUtils.getApiDefaultTimeoutMs();
  const { data: envelope } = await tempMeeApi.get<INpsPromptEnvelope>(NPS_PROMPT_PATH, {
    headers,
    ...(timeoutMs && { timeout: timeoutMs }),
  });

  return envelope.data;
};
